import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const SERVICES = [
  {
    key: "floating_stairs",
    label: "Floating Staircases",
    short: "Floating Stairs",
    description:
      "Hand-built cantilevered and open-tread staircases — sculptural centerpieces built to last.",
    duration: "Custom build",
  },
  {
    key: "replacement",
    label: "Replacements & Installations",
    short: "Replacements & Installs",
    description:
      "Full staircase replacements and new installations — from measurement to finished install.",
    duration: "Multi-day project",
  },
  {
    key: "flooring",
    label: "Hardwood Flooring",
    short: "Flooring",
    description:
      "Precision hardwood flooring laid alongside or independent of your staircase build.",
    duration: "Project-based",
  },
  {
    key: "staining",
    label: "Staining & Finishing",
    short: "Staining",
    description:
      "Custom staining, refinishing and hand-applied finishes that bring out the grain.",
    duration: "1–3 days",
  },
];

export const serviceByKey = (key) =>
  SERVICES.find((s) => s.key === key) || SERVICES[0];

export const BRAND = "TDstaircase";
export const SLOGAN = "We build quality stairs.";
export const CONTACT = {
  email: "tdstaircase8470@gmail.com",
  phone: "519-249-9392",
};
